import React from 'react';
import classNames from 'classnames';
import { InfoIcon, CheckIcon } from 'twain-sport-fe-mono/icons';
import { INotificationMessage } from 'twain-sport-fe-mono/interfaces';
import { NotificationTypes } from 'twain-sport-fe-mono/enums';
import classes from './Notification.module.scss';

interface IProps extends INotificationMessage {
    withBorder?: boolean;
    className?: string;
    dataQa?: string;
}

const IconByType = {
    [NotificationTypes.SUCCESS]: CheckIcon,
    [NotificationTypes.ERROR]: InfoIcon,
    [NotificationTypes.WARNING]: InfoIcon,
    [NotificationTypes.INFO]: InfoIcon,
};

export const Notification: React.FC<IProps> = (props) => {
    const Icon = IconByType[props.type];

    return (
        <div
            className={classNames(classes.notification, classes[props.type], props.className, {
                [classes.withBorder]: props.withBorder,
            })}
            data-qa={props.dataQa}
        >
            <Icon className={classes.icon} />
            <span>{props.message}</span>
        </div>
    );
};
